import { render, staticRenderFns } from "./TheDownloadCount.vue?vue&type=template&id=1dc199eb&scoped=true&"
import script from "./TheDownloadCount.vue?vue&type=script&lang=js&"
export * from "./TheDownloadCount.vue?vue&type=script&lang=js&"
import style0 from "./TheDownloadCount.vue?vue&type=style&index=0&id=1dc199eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc199eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VRow})
